var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouBuilder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    "data-name": "inom bygg"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M17.146 20.809a12.11 12.11 0 0 0 23.84.054",
    "data-name": "Path 40196"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m21.01 60.035-4.144 10.9-1.252 12.11",
    "data-name": "Path 40197"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m37.952 60.5 3.967 10.647 1.044 11.9",
    "data-name": "Path 40198"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.322 40.458 1 46.722l9.812 6.472",
    "data-name": "Path 40199"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m41.169 40.458 14.947 4.8-9.185 7.934",
    "data-name": "Path 40200"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M21.967 46.095h13.988v13.988H21.967z",
    "data-name": "Rectangle 14429"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M23.533 60.083h10.856v11.9H23.533z",
    "data-name": "Rectangle 14430"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M25.308 71.982h7.307v3.132h-7.307z",
    "data-name": "Rectangle 14431"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M27.082 75.114h3.758v1.253h-3.758z",
    "data-name": "Rectangle 14432"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m27.082 76.367 1.879 11.274 1.881-11.274",
    "data-name": "Path 40201"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M35.954 50.897h10.47v4.384h-10.47",
    "data-name": "Path 40202"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M21.969 55.281h-10.47v-4.384h10.47",
    "data-name": "Path 40203"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M17.03 50.897V35.88h24.08v15.017",
    "data-name": "Path 40204"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M41.123 55.281v4.678h-24.08v-4.678",
    "data-name": "Path 40205"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M15.909 17.588h26S43.39 1 28.907 1 15.909 17.588 15.909 17.588Z",
    "data-name": "Path 40206"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M28.906 1v6.451",
    "data-name": "Line 4350"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M22.125 2.65v4.801",
    "data-name": "Line 4351"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M35.09 1.741v5.71",
    "data-name": "Line 4352"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M15.866 14.538s-2.381 3.738-2.136 4.991 8.876 2.206 15.176 2.206 13.691-.589 15.076-1.975-2.1-5.222-2.1-5.222",
    "data-name": "Path 40207"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.547 88.453H40.584v-5.432h10.963z",
    "data-name": "Rectangle 14433"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.143 88.453H7.18v-5.432h10.963z",
    "data-name": "Rectangle 14434"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m9.62 67.921-7.159-6.586",
    "data-name": "Line 4353"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.411 74.697H1.084",
    "data-name": "Line 4354"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m48.213 68.317 7.16-6.586",
    "data-name": "Line 4355"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M48.422 75.092h8.327",
    "data-name": "Line 4356"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouBuilder);
export default __webpack_public_path__ + "static/media/youBuilder.c81628301c8aa11a2c7a54be3f367f1a.svg";
export { ForwardRef as ReactComponent };